import { createSelector } from 'reselect';
import { initialState } from '../Rest/reducerBuilder';
import { selectUserDomain } from '../User/selectors';

/**
 * Other specific selectors
 */

const selectCurrentRoute = state =>
  state.get('routes', initialState).get('current');

const mergeCurrentRoute = (route, user) => {
  if (!route) {
    return undefined;
  }
  const routeJS = route.toJS();
  const userJS = user.toJS();
  const isOwn = userJS && userJS.api && userJS.api.userId === routeJS.user_id;
  return {
    ...routeJS,
    isOwn,
  };
};

/**
 * Default selector used by CurrentRoute
 */

const makeSelectCurrentRoute = () =>
  createSelector([selectCurrentRoute, selectUserDomain], mergeCurrentRoute);

export default makeSelectCurrentRoute;
export { selectCurrentRoute };
